// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"799":"9d5d685f","902":"cf8bd2cf"}[chunkId] + ".chunk.js";
};